/* Auto-generated from authentication-schemas.proto */
export enum IdentityProvider {
    Unknown = 0,
    LiveId = 1,
    OrgId = 2,
    ActiveDirectory = 3,
    ADAL = 4,
    SSPI = 5,
    OAuth2 = 6,
    Badger = 7
}
/**
 * Authentication information for a request
 */
export interface IConfigTicket {
    Provider?: IdentityProvider;
    Policy?: string;
    Target?: string;
    ResourceId?: string;
    AuthorityUrl?: string;
}
/**
 * Supported authentication service parameters for a given service
 */
export interface IAuthTokenRequest {
    Tickets?: IConfigTicket[];
    DocId?: string;
}
/**
 * The token and its corresponding ticket
 */
export interface IAuthTokenResponse {
    Token?: string;
}
export interface IAuthTokenEntry {
    ticket?: IConfigTicket;
    token?: string;
    tokenType?: string;
    userOid?: string;
}
